<template>
    <div class="agendaCenterBox" id="agendaCenterBox">
        <div class="home-title">
            <span class="title-name color000">日程中心</span>
            <div v-if="dateCenterList.length <= 0" class="title-icon" @click="addDate">+</div>
        </div>
        <div class="agendaCenter-main">
            <div class="con-box" :style="{ marginBottom: dateCenterList.length <= 0 ? '20px' : '0' }">
                <div class="con-title">
                    <div class="date-title">{{ sameDay }}</div>
                    <div class="date-time-box">
                        <div class="date-time" @click="clickYear">
                            {{ year }}年
                            <van-icon name="play" />
                        </div>
                        <div class="date-time" @click="clickMonth">
                            {{ month }}月
                            <van-icon name="play" />
                        </div>
                        <div class="date-time" @click="backToToday">回到今天</div>
                    </div>
                </div>
                <div class="con">
                    <canlen
                        :dateList="markDate"
                        @getMonth="clickDay"
                        @arrowFlag="getArrowFlag"
                        :choseDay="choseDay"
                    ></canlen>
                </div>
            </div>

            <div class="date-message-box" :class="{ returnBox: arrowFlag }" v-if="dateCenterList.length > 0">
                <div class="message-box">
                    <van-tabs v-model="active" @click="handleActive">
                        <van-tab
                            v-for="(item, index) in listTttle"
                            :key="index"
                            :title="item.title"
                            :name="item.title"
                        ></van-tab>
                    </van-tabs>
                    <div v-if="active == '全部日程'">
                        <div v-for="(item, index) in dateCenterList" :key="index" @click="clickHandle(item)">
                            <div class="date-message">
                                <div class="data-time">{{ item.time }}</div>
                                <div :class="['date-icon', { 'private-icon': item.scopeType == 'self' }]">
                                    {{ item.scopeType == "self" ? "私" : "公" }}
                                </div>
                                <div class="date-content">{{ item.title }}</div>
                            </div>
                            <div class="date-location">
                                <van-icon name="location-o" size="14" />
                                {{ item.location ? item.location : '无地点' }}
                            </div>
                        </div>
                    </div>
                    <div v-if="active == '会议日程'">
                        <div v-for="(item, index) in dateMetting" :key="index" @click="clickHandle(item)">
                            <div class="date-message">
                                <div class="data-time">{{ item.time }}</div>
                                <div :class="['date-icon', { 'private-icon': item.scopeType == 'self' }]">
                                    {{ item.scopeType == "self" ? "私" : "公" }}
                                </div>
                                <div class="date-content">{{ item.title }}</div>
                            </div>
                          <div class="date-location">
                                <van-icon name="location-o" size="14" />
                                {{ item.location ? item.location : '无地点' }}
                            </div>
                        </div>
                    </div>
                    <div v-if="active == '校务同步'">
                        <div v-for="(item, index) in dateSchool" :key="index" @click="clickHandle(item)">
                            <div class="date-message">
                                <div class="data-time">{{ item.time }}</div>
                                <div :class="['date-icon', { 'private-icon': item.scopeType == 'self' }]">
                                    {{ item.scopeType == "self" ? "私" : "公" }}
                                </div>
                                <div class="date-content">{{ item.title }}</div>
                            </div>

                          <div class="date-location">
                                <van-icon name="location-o" size="14" />
                               {{ item.location ? item.location : '无地点' }}
                            </div>
                        </div>
                    </div>
                    <div v-if="active == '公共日程'">
                        <div v-for="(item, index) in datePublic" :key="index" @click="clickHandle(item)">
                            <div class="date-message">
                                <div class="data-time">{{ item.time }}</div>
                                <div :class="['date-icon', { 'private-icon': item.scopeType == 'self' }]">
                                    {{ item.scopeType == "self" ? "私" : "公" }}
                                </div>
                                <div class="date-content">{{ item.title }}</div>
                            </div>

                          <div class="date-location">
                                <van-icon name="location-o" size="14" />
                                {{ item.location ? item.location : '无地点' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add-icon" @click="addDate">+</div>
            </div>
        </div>
        <van-popup v-model="showYearPicker" position="bottom" :lock-scroll="false" :lazy-render="false">
            <van-picker
                ref="yearPicker"
                show-toolbar
                :columns="yearList"
                @confirm="onConfirmYear"
                @cancel="showYearPicker = false"
                :default-index="yearIndex"
            />
        </van-popup>
        <van-popup v-model="showMonthPicker" position="bottom" :lock-scroll="false" :lazy-render="false">
            <van-picker
                ref="monthPicker"
                show-toolbar
                :columns="monthList"
                @confirm="onConfirmMonth"
                @cancel="showMonthPicker = false"
                :default-index="monthIndex"
            />
        </van-popup>
    </div>
</template>

<script>
    import { RRule, RRuleSet, rrulestr } from "rrule"
    import moment from "moment"
    import axios from "axios"
    import canlen from "@/components/calendar/calendar"
    import { formatDateTime } from "@/utils/dateTimeUtil"
    import { complete, baseURL } from "@/utils/url"
    export default {
        name: "agendaCenter",
        components: {
            canlen,
        },
        data() {
            return {
                active: "全部日程",
                titleData: {
                    title: "日程中心",
                    more: false,
                },
                sameDay: new Date(),
                choseDay: "",
                year: new Date().getFullYear(),
                yearList: [],
                showYearPicker: false,
                month: new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1,
                monthList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                sortMonthList: [],
                day: new Date().getDate() ? "0" + new Date().getDate() : new Date().getDate(),
                showMonthPicker: false,
                dateMessage: [],
                dateCenterList: [], //日程中心列表
                dateMetting: [], //会议日程
                dateSchool: [], //校务同步
                datePublic: [], //公共日程
                markDate: [],
                yearIndex: 0,
                monthIndex: 0,
                arrowFlag: false,
                basePath: baseURL,
                listTttle: [
                    {
                        title: "全部日程",
                    },
                    {
                        title: "会议日程",
                    },
                    {
                        title: "校务同步",
                    },
                    {
                        title: "公共日程",
                    },
                ],
            }
        },
        mounted() {
            //初始化日期
            this.sameDay = formatDateTime(new Date(), "yyyy年MM月dd日")
            this.choseDay = formatDateTime(new Date(), "yyyy-MM-dd")
            this.getNf()
            this.getMonthList(this.choseDay)
            this.get(true)
        },
        methods: {
            addDate() {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                window.location.href = url + "/uCal/m/eventInfo"
            },
            clickHandle(item) {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                window.location.href = url + "/uCal/m/home?d=" + item.data
            },
            handleActive(name) {
                this.active = name
                if (name == "全部日程") {
                    this.dateCenterList = this.dateCenterList
                } else if (name == "会议日程") {
                    this.dateMetting = []
                    this.dateCenterList.map(item => {
                        if (item.eventSource == "meet") {
                            this.dateMetting.push(item)
                        }
                    })
                } else if (name == "校务同步") {
                    this.dateSchool = []
                    this.dateCenterList.map(item => {
                        if (item.eventSource == "sync") {
                            this.dateSchool.push(item)
                        }
                    })
                } else if (name == "公共日程") {
                    this.datePublic = []
                    this.dateCenterList.map(item => {
                        if (item.eventSource == "public") {
                            this.datePublic.push(item)
                        }
                    })
                }
            },
            dayCenter(array, date) {
                // this.handleActive()
                if (
                    array.filter(item => {
                        return (
                            new Date(date) - 0 <= new Date(item.endDate) - 0 &&
                            new Date(date) - 0 >= new Date(item.data) - 0
                        )
                    }).length > 0
                ) {
                    this.dateCenterList = array.filter(item => {
                        return (
                            new Date(date) - 0 <= new Date(item.endDate) - 0 &&
                            new Date(date) - 0 >= new Date(item.data) - 0
                        )
                    })
                    //更新日程中心列表
                    this.dateMetting = []
                    this.dateSchool = []
                    this.datePublic = []
                    this.dateCenterList.map(item => {
                        if (item.eventSource == "meet") {
                            this.dateMetting.push(item)
                        } else if (item.eventSource == "sync") {
                            this.dateSchool.push(item)
                        } else if (item.eventSource == "public") {
                            this.datePublic.push(item)
                        }
                    })
                } else {
                    this.dateCenterList = []
                    // this.dateMetting = []
                    // this.dateSchool =  []
                    // this.datePublic = []
                }
            },
            getMonthList(day) {
                this.sortMonthList = []
                //上个月
                var arr = day.split("-")
                var year = arr[0] //获取当前日期的年份
                var month = arr[1] //获取当前日期的月份
                var year2 = year
                var month2 = parseInt(month) - 1
                if (month2 == 0) {
                    //1月的上一月是前一年的12月
                    year2 = parseInt(year2) - 1
                    month2 = 12
                }
                if (month2 < 10) {
                    //10月之前都需要补0
                    month2 = "0" + month2
                }
                var preMonth = year2 + String(month2)
                //下个月
                var year3 = year
                var month3 = parseInt(month) + 1
                if (month3 == 13) {
                    //12月的下月是下年的1月
                    year3 = parseInt(year3) + 1
                    month3 = 1
                }
                if (month3 < 10) {
                    //10月之前都需要补0
                    month3 = "0" + month3
                }

                var nextMonth = year3 + String(month3)
                this.sortMonthList.push(preMonth)
                this.sortMonthList.push(day.split("-")[0] + day.split("-")[1])
                this.sortMonthList.push(nextMonth)
                // console.log("月份合集", this.sortMonthList)
            },
            getDatThing(month) {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                return new Promise(resolve => {
                    axios.get(url + "/uCal/api/events/queryByMonth?month=" + month).then(res => {
                        var data = res.data.data
                        var resData = []
                        if (data.length > 0) {
                            for (var i = 0; i < data.length; i++) {
                                if (!data[i].rrule) {
                                    resData.push(data[i])
                                }
                            }
                        }
                        resolve(resData)
                    })
                })
            },
            queryAllRecurringEvents(month) {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                return new Promise(resolve => {
                    axios.get(url + "/uCal/api/events/queryAllRecurringEvents").then(res => {
                        resolve(this.getAllRecurringEvent(res.data.data, month))
                    })
                })
            },
            querySyncEventsByMonth(month) {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                return new Promise(resolve => {
                    axios.get(url + "/uCal/api/events/querySyncEventsByMonth?month=" + month).then(res => {
                        var data = res.data.data
                        resolve(this.getAllRecurringEvent(data, month))
                    })
                })
            },
            queryPublicEventsByMonth(month) {
                let url = this.basePath.replace(/(http|https):\/\/([^\/]+)\/.*/i, "$1://$2")
                return new Promise(resolve => {
                    axios
                        .get(url + "/uCal/api/events/queryByMonth?month=" + month + "&userId=public&calendarId=public")
                        .then(res => {
                            var data = res.data.data
                            resolve(this.getAllRecurringEvent(data, month))
                        })
                })
            },
            async get(flag) {
                this.dateMessage = []
                for (let key = 0; key < this.sortMonthList.length; key++) {
                    let data = await this.getDatThing(this.sortMonthList[key])
                    let data2 = await this.querySyncEventsByMonth(this.sortMonthList[key])
                    let data3 = await this.queryPublicEventsByMonth(this.sortMonthList[key])
                    this.dateMessage = [...this.dateMessage, ...data, ...data2, ...data3]
                }
                let data1 = await this.queryAllRecurringEvents(this.sortMonthList[this.sortMonthList.length - 1])
                this.dateMessage = [...this.dateMessage, ...data1]
                this.dateMessage = this.dateMessage.map(item => {
                    return {
                        content: item.description,
                        data: item.start.slice(0, 10),
                        endDate: item.end.slice(0, 10),
                        scopeType: item.scopeType,
                        title: item.title,
                        time: item.start.slice(11, 16),
                        rrule: item.rrule,
                        until: item.until,
                        eventSource: item.eventSource,
                        location: item.location,
                    }
                })

                this.markDate = this.dateMessage.map(item => {
                    return item.data
                })

                this.dateMessage = this.sortList(this.dateMessage)

                //如果选中
                if (flag) {
                    this.dayCenter(this.dateMessage, this.year + "-" + this.month + "-" + this.day)
                }
            },
            // 数据排序
            sortList(list) {
                if (list) {
                    for (var i = 0; i < list.length - 1; i++) {
                        for (var j = 0; j < list.length - 1 - i; j++) {
                            if (new Date(list[j].start) - 0 > new Date(list[j + 1].start) - 0) {
                                var temp = list[j]
                                list[j] = list[j + 1]
                                list[j + 1] = temp
                            }
                        }
                    }
                }
                return list
            },
            getAllRecurringEvent(list, month) {
                var result = []
                if (list.length > 0) {
                    var monthDate = moment(new Date(month.slice(0, 4), month.slice(5, 7), 0)).add(1, "M")
                    for (var i = 0; i < list.length; i++) {
                        if (list[i].rrule) {
                            // if (!list[i].recurrence) {
                            //     continue
                            // }

                            var untilDate = monthDate
                            if (list[i].until && new Date(list[i].until) < untilDate) {
                                untilDate = new Date(list[i].until)
                            }
                            var option = RRule.fromString(list[i].rrule).origOptions
                            option.until = untilDate
                            option.dtstart = new Date(list[i].start)

                            var rule = new RRule(option)

                            var allDate = rule.all()
                            if (allDate.length > 0) {
                                var dateDifference = new Date(list[i].end) - new Date(list[i].start)
                                for (var j = 0; j < allDate.length; j++) {
                                    result.push({
                                        description: list[i].description,
                                        title: list[i].title,
                                        scopeType: list[i].scopeType,
                                        id: list[i].id,
                                        end: moment(new Date(new Date(allDate[j]).getTime() + dateDifference)).format(
                                            "yyyy-MM-DD HH:mm:ss"
                                        ),
                                        eventSource: list[i].eventSource,
                                        start: moment(new Date(allDate[j])).format("yyyy-MM-DD HH:mm:ss"),
                                        location: list[i].location,
                                    })
                                }
                            }
                        } else {
                            result.push(list[i])
                        }
                    }
                }
                return result
            },
            getLastDay(year, month) {
                const date1 = new Date(year, month, 0)
                return date1.getDate()
            },
            getNf() {
                var nfOptionsArray = new Array()
                var years = new Date().getFullYear()
                for (var i = years - 5; i <= years + 5; i++) {
                    nfOptionsArray.push(i)
                }
                this.yearList = nfOptionsArray
                this.yearIndex = this.yearList.indexOf(Number(this.year))
                this.monthIndex = this.monthList.indexOf(this.month)
            },
            clickYear() {
                this.yearIndex = this.yearList.indexOf(Number(this.year))
                this.showYearPicker = true
                this.$nextTick(() => {
                    // 恢复年默认值
                    this.$refs.yearPicker.setColumnIndex(0, this.yearIndex)
                })
            },
            clickMonth() {
                this.monthIndex = this.monthList.indexOf(String(this.month))
                this.showMonthPicker = true
                this.$nextTick(() => {
                    // 恢复月默认值
                    this.$refs.monthPicker.setColumnIndex(0, this.monthIndex)
                })
            },
            backToToday() {
                this.year = new Date().getFullYear() //年
                this.month =
                    new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1 //月
                this.day = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate() // 日
                this.choseDay = this.year + "-" + this.month + "-" + this.day
                this.getMonthList(this.choseDay)
                this.get(true)
            },
            onConfirmYear(value) {
                this.year = value
                this.choseDay = this.year + "-" + this.month + "-" + this.day
                this.getMonthList(this.choseDay)
                this.showYearPicker = false
                this.get(false)
            },
            onConfirmMonth(value) {
                this.month = value
                this.choseDay = this.year + "-" + this.month + "-" + this.day
                this.getMonthList(this.choseDay)
                this.showMonthPicker = false
                this.get(false)
            },
            getArrowFlag(val) {
                this.arrowFlag = !val
            },
            async clickDay(data) {
                var clickDayYear = data.split("-")[0]
                var clickDayMonth = data.split("-")[1]
                var clickDayDay = data.split("-")[2] // 日
                //如果点击月份与当前月份不一致
                // console.log("如果点击月份与当前月份不一致", clickDayMonth, this.month)
                if (clickDayMonth != String(this.month)) {
                    this.choseDay = clickDayYear + "-" + clickDayMonth + "-" + clickDayDay
                    await this.getMonthList(this.choseDay)
                    await this.get(true)
                }
                this.year = clickDayYear
                this.month = clickDayMonth
                this.day = clickDayDay
                this.choseDay = this.year + "-" + this.month + "-" + this.day
                this.dayCenter(this.dateMessage, this.year + "-" + this.month + "-" + this.day)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/css/theme/theme.scss";
    * {
        touch-action: pan-y;
    }
    // 使用全局样式样式去掉
    .agendaCenterBox {
        margin-top: 15px;
        padding: 0 15px 10px 15px;
        background-color: #fff;
    }
    .home-title {
        padding: 15px 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        span.title-name {
            display: inline-flex;
            flex: 1;
            font-weight: 600;
            @extend .font18;
        }
        div.title-icon {
            margin: 0 4px;
            width: 16px;
            height: 16px;
            border-radius: 100%;
            color: var(--main-color);
            border: 1px solid var(--main-color);
            background-color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            @extend .font16;
        }
    }
    .agendaCenter-main {
        margin-bottom: -20px;
        .con-box {
            border-radius: 10px;
            padding-top: 15px;
            border: 1px solid #efefef;
        }
        .con-title {
            padding: 0 20px 5px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;
            line-height: 23px;
        }
        .date-time-box {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
        .date-title {
            color: $c333;
            @extend .font13;
        }
        .date-time {
            color: #fff;
            margin-left: 5px;
            border-radius: 15px;
            padding: 0 5px;
            background-color: var(--main-color);
            @extend .font11;
        }
        .con {
            position: relative;
            max-width: 100%;
        }
        .date-message-box {
            background: url(../../assets/image/home/calendar-bac.jpg) no-repeat center;
            background-size: 100% 100%;
            height: 130px;
            max-height: 130px;
            position: relative;
            top: -18px;
            padding-top: 30px;
            ::v-deep .van-tabs__nav {
                background-color: transparent;
            }
        }
        .returnBox {
            background: url(../../assets/image/home/calendar-bac1.png) no-repeat center;
            background-size: 100% 100%;
            top: -27px;
        }
        .message-box {
            height: 115px;
            max-height: 115px;
            overflow-y: auto;
        }

        .date-message {
            padding: 20px 20px 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;
            box-sizing: border-box;
        }
      .date-location {
        font-size: 12px;
        margin: 10px 0 0 100px;
        width: 184px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #646566;
      }
        .data-time {
            padding-right: 10px;
            @extend .font14;
        }
        .date-icon {
            width: 17px;
            height: 17px;
            border-radius: 100%;
            color: #fff;
            background-color: var(--main-color);
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9;
            @extend .font11;
        }
        .add-icon {
            width: 25px;
            height: 25px;
            border-radius: 100%;
            color: var(--main-color);
            border: 1px solid var(--main-color);
            background-color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9;
            position: absolute;
            right: 13px;
            bottom: 7px;
            @extend .font16;
        }
        .private-icon {
            background-color: #fa9c14;
        }
        .date-content {
            width: 20px;
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @extend .font14;
        }
        ::v-deep .van-icon-play {
            transform: rotate(90deg);
        }
    }
</style>
